import { trafficPeriod, trafficPeriodDetailed } from '@app/pcs/models';
import {gql} from 'apollo-angular';

export const trafficPeriodsResult = 'trafficPeriods';
export const trafficPeriodsQuery = gql`
    query TrafficPeriods ($ttpId: Long!) {
        trafficPeriods (ttpId: $ttpId) {
            ...trafficPeriodDetailed
        }
    }
    ${trafficPeriodDetailed}
`;

export const selectableTrafficPeriodsResult = 'trafficPeriods';
export const selectableTrafficPeriodsQuery = gql`
  query TrafficPeriods ($ttpId: Long!) {
    trafficPeriods (ttpId: $ttpId) {
      ...trafficPeriod
    }
  }
  ${trafficPeriod}
`;

export const trafficPeriodResult = 'trafficPeriod';
export const trafficPeriodQuery = gql`
  query TrafficPeriod ($id: Long!) {
    trafficPeriod (id: $id) {
      ...trafficPeriodDetailed
    }
  }
  ${trafficPeriodDetailed}
`;

export const trafficPeriodTemplateResult = 'trafficPeriodTemplate';
export const trafficPeriodTemplateQuery = gql`
    query TrafficPeriods ($ttpId: Long!) {
        trafficPeriodTemplate (ttpId: $ttpId) {
            ...trafficPeriodDetailed
        }
    }
    ${trafficPeriodDetailed}
`;

export const validatePeriodInServiceCodeResult = 'validatePeriodInServiceCode';
export const validatePeriodInServiceCodeQuery = gql`
    query ValidatePeriodInServiceCode ($trafficPeriod: TrafficPeriodInput!) {
        validatePeriodInServiceCode (trafficPeriod: $trafficPeriod)
    }
`;
